(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-countdown-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function init(root) {
    if (!root || root.dataset.hcbReady) return;
    root.dataset.hcbReady = '1';
    var end = Date.parse(root.getAttribute('data-end') || '');
    var timer = root.querySelector('[data-hcb-timer]');
    if (!timer || isNaN(end)) return;
    var els = { d: timer.querySelector('[data-u="d"]'), h: timer.querySelector('[data-u="h"]'), m: timer.querySelector('[data-u="m"]'), s: timer.querySelector('[data-u="s"]') };
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { root.hidden = true; root.style.display = 'none'; clearInterval(iv); return; }
      els.d.textContent = pad(Math.floor(left / 86400));
      els.h.textContent = pad(Math.floor(left % 86400 / 3600));
      els.m.textContent = pad(Math.floor(left % 3600 / 60));
      els.s.textContent = pad(left % 60);
      timer.hidden = false;
    }
    var iv = setInterval(tick, 1000);
    tick();
  }
  function boot() { document.querySelectorAll('[data-hcb]').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-premium"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.fpReady) return;
    root.dataset.fpReady = '1';

    var dataEl = root.querySelector('[data-fp-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = root.querySelector('[data-fp-id]');
    var priceEl = root.querySelector('[data-fp-price]');
    var nowEl = root.querySelector('[data-fp-now]');
    var wasEl = root.querySelector('[data-fp-was]');
    var badges = root.querySelectorAll('[data-fp-badge]');
    var badgePct = root.querySelector('[data-fp-badge-pct]');
    var atc = root.querySelector('[data-fp-atc]');
    var atcText = root.querySelector('[data-fp-atc-text]');
    var barAtc = root.querySelector('[data-fp-bar-atc]');
    var barPrice = root.querySelector('[data-fp-bar-price]');
    var barVariant = root.querySelector('[data-fp-bar-variant]');
    var bar = root.querySelector('[data-fp-bar]');
    var media = root.querySelector('[data-fp-media]');
    var idxEl = root.querySelector('[data-fp-index]');
    var progEl = root.querySelector('[data-fp-progress]');
    var flagEl = root.querySelector('[data-fp-flag]');
    var abarEl = root.querySelector('[data-fp-abar]');
    var abarFill = root.querySelector('[data-fp-abar-fill]');
    var lowMax = parseInt(root.getAttribute('data-fp-low'), 10) || 10;
    var soldOut = atc ? atc.getAttribute('data-sold-out') : null;
    var viewersEl = root.querySelector('[data-fp-viewers]');
    if (viewersEl) viewersEl.textContent = 8 + Math.floor(Math.random() * 13);

    function selected() {
      var out = [];
      root.querySelectorAll('[data-fp-input]').forEach(function (i) {
        if (i.tagName === 'SELECT' || i.checked) out[parseInt(i.dataset.fpInput, 10)] = i.value;
      });
      return out;
    }

    function match(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== undefined && v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function markSelection() {
      root.querySelectorAll('.fp__swatch, .fp__tile').forEach(function (l) {
        var i = l.querySelector('input');
        l.classList.toggle('is-selected', !!(i && i.checked));
      });
      root.querySelectorAll('[data-fp-option-value]').forEach(function (em) {
        var idx = parseInt(em.dataset.fpOptionValue, 10);
        var i = root.querySelector('[data-fp-input="' + idx + '"]:checked');
        if (i) em.textContent = i.value;
      });
    }

    function markAvailability() {
      var opts = selected();
      root.querySelectorAll('.fp__tile').forEach(function (l) {
        var i = l.querySelector('input');
        if (!i) return;
        var idx = parseInt(i.dataset.fpInput, 10);
        var probe = opts.slice();
        probe[idx] = i.value;
        var v = match(probe);
        l.classList.toggle('is-unavailable', !v || !v.available);
      });
      root.querySelectorAll('select[data-fp-input]').forEach(function (sel) {
        var idx = parseInt(sel.dataset.fpInput, 10);
        for (var i = 0; i < sel.options.length; i++) {
          var probe = opts.slice();
          probe[idx] = sel.options[i].value;
          var v = match(probe);
          sel.options[i].disabled = !v || !v.available;
        }
      });
    }

    function scrollToMedia(pos) {
      if (pos === null || pos === undefined || !media) return;
      var slide = media.children[pos];
      if (!slide) return;
      if (window.matchMedia('(min-width: 990px)').matches) {
        slide.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        media.scrollTo({ left: slide.offsetLeft - media.offsetLeft, behavior: 'smooth' });
      }
    }

    function update() {
      markSelection();
      markAvailability();
      var v = match(selected());
      if (!v) {
        if (atc) { atc.disabled = true; }
        if (barAtc) { barAtc.disabled = true; }
        if (atcText && soldOut) atcText.textContent = soldOut;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (nowEl) nowEl.innerHTML = v.price;
      if (wasEl) wasEl.innerHTML = v.compare ? v.compare : '';
      if (priceEl) priceEl.classList.toggle('is-sale', !!v.compare);
      badges.forEach(function (el) { el.hidden = !v.pct; });
      if (v.pct && badgePct) badgePct.textContent = v.pct;
      if (barPrice) barPrice.innerHTML = v.price;
      if (barVariant) barVariant.textContent = v.title ? ' · ' + v.title : '';
      if (atc) atc.disabled = !v.available;
      if (barAtc) barAtc.disabled = !v.available;
      if (atcText && soldOut) atcText.textContent = v.available ? atc.dataset.fpLabel : soldOut;
      var low = v.available;
      if (flagEl) flagEl.hidden = !low;
      if (abarEl) {
        abarEl.hidden = !low;
        if (low && abarFill) {
          var pctw = (v.untracked || v.inv > lowMax) ? 25 : Math.round(v.inv * 100 / lowMax);
          abarFill.style.width = (pctw < 8 ? 8 : pctw) + '%';
        }
      }
      if (history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
      scrollToMedia(v.media);
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-fp-input]')) update();
    });

    if (media && idxEl) {
      media.addEventListener('scroll', function () {
        var w = media.clientWidth || 1;
        var i = Math.round(media.scrollLeft / w) + 1;
        var total = media.children.length;
        if (i < 1) i = 1;
        if (i > total) i = total;
        idxEl.textContent = i;
        if (progEl) progEl.style.width = (i / total) * 100 + '%';
      }, { passive: true });
    }

    if (bar && atc) {
      var onScroll = function () {
        var r = atc.getBoundingClientRect();
        bar.hidden = false;
        bar.classList.toggle('is-visible', r.bottom < 0);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
    }

    markSelection();
    markAvailability();
  }

  function boot() { document.querySelectorAll('[data-fp]').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-tahari"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.tpReady) return;
    root.dataset.tpReady = '1';

    var dataEl = root.querySelector('[data-tp-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var q = function (s) { return root.querySelector(s); };
    var idInput = q('[data-tp-id]');
    var strip = q('[data-tp-strip]');
    var nowEl = q('[data-tp-now]');
    var wasEl = q('[data-tp-was]');
    var badges = root.querySelectorAll('[data-tp-badge]');
    var badgePct = q('[data-tp-badge-pct]');
    var atc = q('[data-tp-atc]');
    var atcText = q('[data-tp-atc-text]');
    var barAtc = q('[data-tp-bar-atc]');
    var barPrice = q('[data-tp-bar-price]');
    var barVariant = q('[data-tp-bar-variant]');
    var bar = q('[data-tp-bar]');
    var media = q('[data-tp-media]');
    var idxEl = q('[data-tp-index]');
    var flagEl = q('[data-tp-flag]');
    var abarEl = q('[data-tp-abar]');
    var abarFill = q('[data-tp-abar-fill]');
    var lowMax = parseInt(root.getAttribute('data-tp-low'), 10) || 10;
    var soldOut = atc ? atc.getAttribute('data-sold-out') : null;
    var viewersEl = q('[data-tp-viewers]');
    if (viewersEl) viewersEl.textContent = 8 + Math.floor(Math.random() * 13);

    function selected() {
      var out = [];
      root.querySelectorAll('[data-tp-input]').forEach(function (i) {
        if (i.checked) out[parseInt(i.dataset.tpInput, 10)] = i.value;
      });
      return out;
    }

    function match(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== undefined && v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function markSelection() {
      root.querySelectorAll('.tp__swatch, .tp__tile').forEach(function (l) {
        var i = l.querySelector('input');
        l.classList.toggle('is-selected', !!(i && i.checked));
      });
      root.querySelectorAll('[data-tp-option-value]').forEach(function (em) {
        var i = root.querySelector('[data-tp-input="' + em.dataset.tpOptionValue + '"]:checked');
        if (i) em.textContent = i.value;
      });
    }

    function markAvailability() {
      var opts = selected();
      root.querySelectorAll('.tp__tile').forEach(function (l) {
        var i = l.querySelector('input');
        var probe = opts.slice();
        probe[parseInt(i.dataset.tpInput, 10)] = i.value;
        var v = match(probe);
        l.classList.toggle('is-unavailable', !v || !v.available);
      });
    }

    function scrollToMedia(pos) {
      if (pos === null || pos === undefined || !media) return;
      var slide = media.children[pos];
      if (!slide) return;
      if (window.matchMedia('(min-width: 990px)').matches) {
        slide.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        media.scrollTo({ left: slide.offsetLeft - media.offsetLeft, behavior: 'smooth' });
      }
    }

    function update() {
      markSelection();
      markAvailability();
      var v = match(selected());
      if (!v) {
        if (atc) atc.disabled = true;
        if (barAtc) barAtc.disabled = true;
        if (atcText && soldOut) atcText.textContent = soldOut;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (nowEl) nowEl.innerHTML = v.price;
      if (wasEl) wasEl.innerHTML = v.compare ? v.compare : '';
      if (strip) strip.classList.toggle('is-sale', !!v.compare);
      badges.forEach(function (el) { el.hidden = !v.pct; });
      if (v.pct && badgePct) badgePct.textContent = v.pct;
      if (barPrice) barPrice.innerHTML = v.price;
      if (barVariant) barVariant.textContent = v.title ? ' · ' + v.title : '';
      if (atc) atc.disabled = !v.available;
      if (barAtc) barAtc.disabled = !v.available;
      if (atcText && soldOut) atcText.textContent = v.available ? atc.dataset.tpLabel : soldOut;
      if (flagEl) flagEl.hidden = !v.available;
      if (abarEl) {
        abarEl.hidden = !v.available;
        if (v.available && abarFill) {
          var w = (v.untracked || v.inv > lowMax) ? 25 : Math.round(v.inv * 100 / lowMax);
          abarFill.style.width = (w < 8 ? 8 : w) + '%';
        }
      }
      if (history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
      scrollToMedia(v.media);
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-tp-input]')) update();
    });

    var jump = q('[data-tp-jump]');
    if (jump) {
      jump.addEventListener('click', function () {
        var reviews = document.querySelector('[data-fwr]');
        if (reviews) reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    if (media && idxEl) {
      media.addEventListener('scroll', function () {
        var w = media.clientWidth || 1;
        var total = media.children.length;
        var i = Math.min(total, Math.max(1, Math.round(media.scrollLeft / w) + 1));
        idxEl.textContent = i;
      }, { passive: true });
    }

    if (bar && atc) {
      var onScroll = function () {
        bar.hidden = false;
        bar.classList.toggle('is-visible', atc.getBoundingClientRect().bottom < 0);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
    }

    markSelection();
    markAvailability();
  }

  function boot() { document.querySelectorAll('[data-tp]').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();

  } catch(e) { console.error(e); }
})();
})();
